import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "registration-card" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "i-preloader__item" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 0,
  class: "ds-panel ds-panel--space_2xl"
}
const _hoisted_5 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_6 = { class: "ds-caption ds-caption--size_md ds-caption--appearance_center" }
const _hoisted_7 = { class: "ds-panel ds-panel--space_lg" }
const _hoisted_8 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_9 = { class: "ds-caption ds-caption--size_lg ds-caption--weight_semi-bold ds-caption--appearance_center" }
const _hoisted_10 = { class: "ds-panel ds-panel--space_md" }
const _hoisted_11 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_12 = { class: "ds-caption ds-caption--size_md ds-caption--appearance_center" }
const _hoisted_13 = { class: "ds-panel ds-panel--space_md" }
const _hoisted_14 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_15 = {
  key: 0,
  class: "ds-caption ds-caption--size_sm ds-caption--appearance_center"
}
const _hoisted_16 = {
  key: 0,
  class: "ds-panel ds-panel--space_sm"
}
const _hoisted_17 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_18 = { class: "ds-caption ds-caption--size_sm ds-caption--appearance_center" }
const _hoisted_19 = {
  key: 1,
  class: "ds-panel ds-panel--space_sm"
}
const _hoisted_20 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_21 = { class: "ds-caption ds-caption--size_sm ds-caption--appearance_center" }
const _hoisted_22 = { class: "ds-panel ds-panel--space_2xl" }
const _hoisted_23 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_24 = { class: "g-row g-row--justify_center" }
const _hoisted_25 = { class: "g-cell" }
const _hoisted_26 = ["src", "alt"]
const _hoisted_27 = { class: "ds-panel ds-panel--space_xl" }
const _hoisted_28 = { class: "ds-panel__element ds-panel__element--offset_top" }
const _hoisted_29 = { class: "g-row g-row--justify_center" }
const _hoisted_30 = { class: "g-cell" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_control_button = _resolveComponent("control-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["i-preloader", { 'is-active': $setup.isLoad }])
    }, _hoisted_3, 2),
    ($setup.loadError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", _hoisted_6, _toDisplayString($setup.$t("Не вдалося завантажити картку реєстрації")), 1)
          ])
        ]))
      : ($setup.card)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("p", _hoisted_9, _toDisplayString($setup.card.fullName), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("p", _hoisted_12, _toDisplayString($setup.card.event), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("p", {
                  class: _normalizeClass(["ds-caption ds-caption--size_md ds-caption--appearance_center", { 'is-success': $setup.card.checkedIn }])
                }, _toDisplayString($setup.card.checkedIn ? $setup.$t("Присутній") : $setup.$t("Не відмічено")), 3),
                ($setup.card.checkedIn && $setup.card.checkInTime)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_15, _toDisplayString($setup.formattedCheckInTime), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            ($setup.card.email)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("p", _hoisted_18, _toDisplayString($setup.card.email), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            ($setup.card.phone)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("p", _hoisted_21, _toDisplayString($setup.card.phone), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("img", {
                      class: "registration-card__qr",
                      src: $props.qrImageUrl,
                      alt: $setup.$t('QR-код для чекіну')
                    }, null, 8, _hoisted_26)
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_control_button, {
                      disabled: $setup.isDownloading,
                      onClick: _withModifiers($setup.downloadQr, ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString($setup.$t("Завантажити QR")), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ])
              ])
            ])
          ], 64))
        : _createCommentVNode("", true)
  ]))
}